import { render, staticRenderFns } from "./ModeratorForm1.vue?vue&type=template&id=75becfd7&scoped=true&"
import script from "./ModeratorForm1.vue?vue&type=script&lang=js&"
export * from "./ModeratorForm1.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorForm1.vue?vue&type=style&index=0&id=75becfd7&scoped=true&lang=css&"
import style1 from "./ModeratorForm1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75becfd7",
  null
  
)

export default component.exports